import { forwardRef } from "react";
import { FormControl } from "../FormControl";
import { useFormControlProps } from "../hooks";
import type { BaseFormProps } from "../types";
import type { BaseRadioProps } from "./BaseRadio";
import { BaseRadio } from "./BaseRadio";

export type RadioProps = BaseRadioProps & BaseFormProps;

const RadioInner = (props: RadioProps, ref: React.ForwardedRef<HTMLButtonElement>) => {
	const { formControlProps, errorAria, baseProps: radioProps } = useFormControlProps(props);

	return (
		<FormControl {...formControlProps}>
			<BaseRadio {...radioProps} {...errorAria} ref={ref} />
		</FormControl>
	);
};

RadioInner.displayName = "Radio";

export const Radio = forwardRef(RadioInner);
